import React from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import MaterialSearch from './components/MaterialSearch';
import PublicationsPage from './components/Publications';
import PublicationDetails from './components/PublicationDetails';
import PlotlyGraph from './components/PlotlyGraph';
import AboutPage from './components/AboutPage';
import CrystalStructureViewer from './components/CrystalStructureViewer'

const client = new ApolloClient({
  uri: "https://api-catalysis-hub.slac.stanford.edu/graphql",
  cache: new InMemoryCache({
    addTypename: false,
  }),
});


function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<MaterialSearch/>} />
            <Route path="/publications" element={<PublicationsPage />} />
            <Route path="/publications/:id" element={<PublicationDetails />} />
            <Route path="/test" element={<PlotlyGraph />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/CrystalStructureViewer" element={<CrystalStructureViewer />} />
          </Routes>
        </div>
      </Router>
    </ApolloProvider>
  );
}
export default App;